/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';

export interface RemoveUser$Request {
    userId: number;
    reason?: string;
}

export interface RemoveUser$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const removeUserRequest = createAction<PayloadData<void, RemoveUser$Request>>('USER_LIFECYCLE__REMOVE_USER__REQUEST');
export const removeUserSuccess = createAction<PayloadData<void, RemoveUser$Request>>('USER_LIFECYCLE__REMOVE_USER__SUCCESS');
export const removeUserFailure = createAction<PayloadData<Error, RemoveUser$Request, true>>('USER_LIFECYCLE__REMOVE_USER__FAILURE');

export const removeUserActions = [
    removeUserRequest,
    removeUserSuccess,
    removeUserFailure
] as const;

/**
 * @param {number} meta.userId
 * @param {string} [meta.reason] Optional audit reason for this update. Blank values use the existing operation-specific reason.
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const removeUser = (meta: RemoveUser$Request, config?: RemoveUser$Config) => {
    const TRANSPORT_GET_PARAMS = {
        reason: meta.reason,
    };
    return {
        CALL_API: {
            types: removeUserActions,
            method: ApiMethods.DELETE,
            endpoint: `/web-api/users/${meta.userId}`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface RestoreUser$Request {
    userId: number;
    reason?: string;
}

export interface RestoreUser$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const restoreUserRequest = createAction<PayloadData<void, RestoreUser$Request>>('USER_LIFECYCLE__RESTORE_USER__REQUEST');
export const restoreUserSuccess = createAction<PayloadData<void, RestoreUser$Request>>('USER_LIFECYCLE__RESTORE_USER__SUCCESS');
export const restoreUserFailure = createAction<PayloadData<Error, RestoreUser$Request, true>>('USER_LIFECYCLE__RESTORE_USER__FAILURE');

export const restoreUserActions = [
    restoreUserRequest,
    restoreUserSuccess,
    restoreUserFailure
] as const;

/**
 * @param {number} meta.userId
 * @param {string} [meta.reason] Optional audit reason for this update. Blank values use the existing operation-specific reason.
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const restoreUser = (meta: RestoreUser$Request, config?: RestoreUser$Config) => {
    const TRANSPORT_GET_PARAMS = {
        reason: meta.reason,
    };
    return {
        CALL_API: {
            types: restoreUserActions,
            method: ApiMethods.PATCH,
            endpoint: `/web-api/users/${meta.userId}`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

